import { AnimatePresence, motion } from "framer-motion";
import React, { useState, useEffect } from "react";
import { FaAngleRight } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { updateNavbarHeading } from "../constants/layout/store/filterSlice";
import { useDispatch } from "react-redux";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const menuAnimation = {
  hidden: {
    opacity: 0,
    height: 0,
    padding: 0,
    transition: { duration: 0.3, when: "afterChildren" },
  },
  show: {
    opacity: 1,
    height: "auto",
    transition: {
      duration: 0.3,
      when: "beforeChildren",
    },
  },
};

const menuItemAnimation = {
  hidden: (i) => ({
    padding: 0,
    x: "-100%",
    transition: {
      duration: (i + 1) * 0.1,
    },
  }),
  show: (i) => ({
    x: 0,
    transition: {
      duration: (i + 1) * 0.1,
    },
  }),
};

// const SidebarMenu = ({ route, showAnimation, isOpen, setIsOpen }) => {
const SidebarMenu = ({
  route,
  activePaths,
  showAnimation,
  isOpen,
  setIsOpen,
}) => {

  console.log("isOpen, activePaths, route",isOpen, activePaths, route);
  
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setIsOpen(true);
  };
  //   useEffect(() => {
  //     if (!isOpen) {
  //         setIsMenuOpen(false);
  //     }
  //     if (isOpen && activePaths.includes(route.name)) setIsMenuOpen(true)
  // }, [isOpen]);
  useEffect(() => {
    if (!isOpen) {
      setIsMenuOpen(false);
    }
    if (
      isOpen &&
      Array.isArray(activePaths) &&
      route?.name &&
      activePaths.includes(route.name)
    ) {
      setIsMenuOpen(true);
    }
  }, [isOpen, activePaths, route]);

  // useEffect(() => {
  //   if (!isOpen) {
  //     setIsMenuOpen(false);
  //   }
  // }, [isOpen]);

  return (
    <>
      <div className="menu" onClick={toggleMenu}>
        <div className="menu_item">
          {
          !isOpen ? (
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip id="tooltip-top">  {route.name
                  .split(" ")
                  .map((word) => {
                    if (word == "RMG") {
                      return word.toUpperCase();
                    } else {
                      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                    }
                  })
                  .join(" ")}</Tooltip>}
            >
              <div className="icon"  style={{cursor:"pointer"}}>{route.icon}</div>
            </OverlayTrigger>
          ) : (
            <div className="icon" style={{cursor:"pointer"}}>{route.icon}</div>
          )}

          <AnimatePresence>
            {isOpen && (
              <motion.div
                variants={showAnimation}
                initial="hidden"
                animate="show"
                exit="hidden"
                className="link_text"
              >
                {route.name
                  .split(" ")
                  .map((word) => {
                    if (word == "RMG") {
                      return word.toUpperCase();
                    } else {
                      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                    }
                  })
                  .join(" ")}
              </motion.div>
            )}
          </AnimatePresence>
        </div>
        {isOpen && (
          <motion.div
            animate={
              isMenuOpen
                ? {
                  rotate: 90,
                }
                : { rotate: 0 }
            }
          >
            <FaAngleRight className="arrow-icon pe-2" />
          </motion.div>
        )}
      </div>
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            variants={menuAnimation}
            initial="hidden"
            animate="show"
            exit="hidden"
            className="menu_container"
          >
            {route.subRoutes.map((subRoute, i) => (
              <motion.div variants={menuItemAnimation} key={i} custom={i}>
                {subRoute.subRoutes ? (
                  <SidebarMenu
                    activePaths={activePaths}
                    route={subRoute}
                    showAnimation={showAnimation}
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                  />
                ) : (

                  <NavLink
                    to={subRoute.path}
                    className={({ isActive }) =>
                      isActive ? "link active-link" : "link"
                    }
                    style={({ isActive }) => ({
                      color: isActive ? "#27568B" : "inherit",
                      backgroundColor: isActive ? "#fff" : "transparent",
                      borderRadius: isActive ? "5px" : "0",
                      padding: "6px 8px",
                    })}
                    // className="link"
                    // exact
                    // isActive={(match, location) => match && match.isExact}
                    // activeClassName="active-link"
                    onClick={() => {
                      setIsOpen(false); // Proper function call
                    }}
                  >

                    <div className="icon">{subRoute.icon}</div>

                    <motion.div className="link_text">
                      {subRoute.name}
                    </motion.div>
                  </NavLink>
                )}
              </motion.div>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default SidebarMenu;
